import React, {useState} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import { updateFaqCategoryAction } from '../../../actions/faqAction';
import { InputProfile } from '../../../utils/input/InputProfile';

export function FaqCategoryModal({item, trigger, triggerWrap, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    id: item ? item.id : '',
    name: item ? item.name : ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = (field, value) => {
    setForm((form) => {
      return {...form, [field]: value};
    });
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let err = false;
    let errors = {};
    if (form.name.trim() === '') {
      err = true;
      errors.name = true;
    }

    setErrors(errors);
    if (err) {
      return false;
    }
    setLoading(true);

    dispatch(updateFaqCategoryAction(form)).then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">{item ? "Изменить" : "Добавить"} категорию</div>
      <div className="modal__wrap">
          <InputProfile type="text"
                        title="Название"
                        name="name"
                        placeholder="Введите название"
                        value={form.name}
                        error={errors.name || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('name', e.target.value)}/>
              
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
      </div>
    </React.Fragment>
  </Modal>
};
